import { DataGridCellParams } from "@components/common/data-grid/adm-data-grid-types";
import { AdmProject } from "@custom-types/base-types";

/** The column definition for the search projects table with the field property typed */
export type SearchProjectsTableGridColDef = DataGridCellParams<
  AdmProject,
  SearchProjectsTableColumnField
>;

/** The column fields that can be used in the search projects table */
export type SearchProjectsTableColumnField =
  | "name"
  | "id"
  | "area"
  | "storageSize"
  | "workspace"
  | "manager"
  | "createdAt"
  | "standalone"
  | "options";

/** The labels for the columns in the search projects table */
export const SEARCH_PROJECTS_TABLE_COLUMN_LABELS: Record<
  SearchProjectsTableColumnField,
  string
> = {
  name: "Name",
  id: "Project Id",
  area: "Area",
  storageSize: "Storage Size",
  workspace: "Workspace",
  manager: "Project Manager",
  createdAt: "Created At",
  standalone: "Standalone",
  options: "",
};
